import React, { Component } from "react";

export default class Impressum extends Component {
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "instant" });
  }

  render() {
    return (
      <div className="container">
        <div className="padding-block-500">
          <div className="misc-heading ">Impressum</div>
          <div className="misc-paragraph">
            <br />
            <h3 className="fw-bold">Angaben gemäß § 5 TMG</h3>
            <br />
            <p>Ärzte- und Gesundheitsnetz Südbrandenburg e. V.</p>
            <p>Westfalenstraße 2</p>
            <p>03238 Finsterwalde</p>
            <br />
            <p>Vertreten durch:</p>
            <p>Andrea Trunev (Vorsitzende des Vorstands)</p>
            <p>Dr. med. Anne Bräutigam (Stellv. Vorsitzende des Vorstands)</p>
            <br />
            <p>Kontakt</p>
            <p>Telefon: +49 (0) 1523 1929494</p>
            <p>E-Mail: info@an-sb.de</p>
            <br />
            <p>Rechtsform: eingetragener Verein</p>
            <p>Sitz des Vereins: Finsterwalde</p>
            <p>Registergericht: Cottbus</p>
            <p>Registernummer: VR 6278 CB</p>
            <p>Steuernummer: 057/143/05206</p>
            <p>Finanzamt: Calau</p>
            <br />
            <h3 className="fw-bold">Redaktionell Verantwortlicher</h3>
            <p>Andrea Trunev (Netzwerkkoordination)</p>
            <p>Westfalenstraße 2 </p>
            <p>03238 Finsterwalde</p>
            <br />
            <br />
            <h3 className="fw-bold">
              Verbraucherstreitbeilegung/Universalschlichtungsstelle
            </h3>
            <p>
              Wir sind nicht verpflichtet, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            <br />
            <h3 className="fw-bold">Haftung für Inhalte</h3>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur
              Entfernung oder Sperrung der Nutzung von Informationen nach den
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine
              diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
              diese Inhalte umgehend entfernen.
            </p>
            <br />
            <h3 className="fw-bold">Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle
              der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
              Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
            <br />
            <h3 className="fw-bold">Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht
              kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
              Seite nicht vom Betreiber erstellt wurden, werden die
              Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
              Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
              Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
              entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
              werden wir derartige Inhalte umgehend entfernen.
            </p>
            <br />
            <a href="https://www.e-recht24.de ">Quelle: eRecht24</a>
          </div>
        </div>
      </div>
    );
  }
}
